import { paths } from 'src/routes/paths';

export const { VITE_API_URL: API_URL } = import.meta.env;
export const { VITE_CLIENT_HOST: CLIENT_HOST } = import.meta.env;

export const PATH_AFTER_LOGIN = paths.app.root;

export const STORAGE_KEY_ACCESS = '@nectar_market/access_token';
export const STORAGE_KEY_REFRESH = '@nectar_market/refresh_token';
